/* import __COLOCATED_TEMPLATE__ from './input-group.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import snakeCase from 'lodash.snakecase';

export default class InputGroup extends Component {
    tagName = '';

    @action onInputGroupValueChange() {
        if (this.onValueChange) this.onValueChange();
    }

    @computed('inputId') get errorId() {
        return `${this.inputId}Error`;
    }

    @computed('qaAttrValue', 'inputId') get internalQaAttrValue() {
        return this.qaAttrValue || snakeCase(this.inputId.replace('Input', ''));
    }
}
